export const superAdminMenu = (permissions) => {

    const menuItems =
    [
        {
            name: "Dashboard",
            URL: "/super-admin/home",
            icon: "Home_sup.png",
            isHidden : permissions.find((obj)=> obj?.objectName === "Home")?.isHidden || false,
            readOnly : permissions.find((obj)=> obj?.objectName === "Home")?.permission.length === 1 && permissions.find((obj)=> obj?.objectName === "Home")?.permission.includes('read')
        },
        {
            name: "Organizations",
            URL: "/super-admin/organization",
            icon: "Organization_sup.png",
            isHidden : permissions.find((obj)=> obj?.objectName === "Organizations")?.isHidden || false,
            readOnly : permissions.find((obj)=> obj?.objectName === "Organizations")?.permission.length === 1 && permissions.find((obj)=> obj?.objectName === "Organizations")?.permission.includes('read')
        },
        {
            name: "Workflow",
            URL: "/super-admin/workflow",
            icon: "workflow_sup.png",
            isHidden : permissions.find((obj)=> obj?.objectName === "Workflow")?.isHidden || false,
            readOnly : permissions.find((obj)=> obj?.objectName === "Workflow")?.permission.length === 1 && permissions.find((obj)=> obj?.objectName === "Workflow")?.permission.includes('read')
        },
        {
            name: "Users",
            URL: "/super-admin/users",
            icon: "users_sup.png",
            isHidden : permissions.find((obj)=> obj?.objectName === "Users")?.isHidden || false,
            readOnly : permissions.find((obj)=> obj?.objectName === "Users")?.permission.length === 1 && permissions.find((obj)=> obj?.objectName === "Users")?.permission.includes('read')
        },
        {
            name: "Support",
            URL: "/super-admin/support",
            icon: "support_sup.png",
            isHidden : permissions.find((obj)=> obj?.objectName === "SupportRequests")?.isHidden || false,
            readOnly : permissions.find((obj)=> obj?.objectName === "SupportRequests")?.permission.length === 1 && permissions.find((obj)=> obj?.objectName === "SupportRequests")?.permission.includes('read')
        },
        {
            name: "Messages",
            URL: "/super-admin/messages",
            icon: "Messages_sup.png",
            isHidden : permissions.find((obj)=> obj?.objectName === "Messages")?.isHidden || false,
            readOnly : permissions.find((obj)=> obj?.objectName === "Messages")?.permission.length === 1 && permissions.find((obj)=> obj?.objectName === "Messages")?.permission.includes('read')
        }
        // {
        //     name: "Insights",
        //     URL: "/super-admin/analytics",
        //     icon: "Insights_sup.png",
        //     isHidden : permissions.find((obj)=> obj?.objectName === "Insights")?.isHidden || false,
        //     readOnly : permissions.find((obj)=> obj?.objectName === "Insights")?.permission.length === 1 && permissions.find((obj)=> obj?.objectName === "Insights")?.permission.includes('read')
        // }
    ];
    return menuItems;
};
export const clinicAdminMenu = (permissions) => {
    const menuItems =
    [
        {
            name: "Dashboard",
            URL: "/app/home",
            icon: "Home_sup.png",
            isHidden : permissions.find((obj)=> obj?.objectName === "Home")?.isHidden || false,
            readOnly : permissions.find((obj)=> obj?.objectName === "Home")?.permission.length === 1 && permissions.find((obj)=> obj?.objectName === "Home")?.permission.includes('read') || false
        },
        {
            name: "Activity",
            URL: "/app/activity",
            icon: "activities_admin.png",
            isHidden : permissions.find((obj)=> obj?.objectName === "ActionsTaskAndMeeting")?.isHidden || false,
            readOnly : permissions.find((obj)=> obj?.objectName === "ActionsTaskAndMeeting")?.permission.length === 1 && permissions.find((obj)=> obj?.objectName === "ActionsTaskAndMeeting")?.permission.includes('read') || false

        },
        {
            name: "Snapshot",
            URL: "/app/snapshot",
            icon: "Dashboard.png",
            isHidden : permissions.find((obj)=> obj?.objectName === "Dashboard")?.isHidden || false,
            readOnly : permissions.find((obj)=> obj?.objectName === "Dashboard")?.permission.length === 1 && permissions.find((obj)=> obj?.objectName === "Dashboard")?.permission.includes('read') || false
        },
        {
            name: "Patients",
            URL: "/clinic/patient-list",
            icon: "patient_admin.png",
            isHidden : permissions.find((obj)=> obj?.objectName === "Patients")?.isHidden || false,
            readOnly : permissions.find((obj)=> obj?.objectName === "Patients")?.permission?.length === 1 && permissions.find((obj)=> obj?.objectName === "Patients")?.permission.includes('read') || false
        },
        {
            name: "Applications",
            URL: "/app/admin-application",
            icon: "Applicationuser_admin.png",
            isHidden : permissions.find((obj)=> obj?.objectName === "Applications")?.isHidden || false,
            readOnly : permissions.find((obj)=> obj?.objectName === "Applications")?.permission.length === 1 && permissions.find((obj)=> obj?.objectName === "Applications")?.permission.includes('read') || false
        },
        {
            name: "Actions",
            URL: "/app/actions",
            icon: "action_admin.png",
            isHidden : permissions.find((obj)=> obj?.objectName === "ActionsTaskAndMeeting")?.isHidden || false,
            readOnly : permissions.find((obj)=> obj?.objectName === "ActionsTaskAndMeeting")?.permission.length === 1 && permissions.find((obj)=> obj?.objectName === "ActionsTaskAndMeeting")?.permission.includes('read') || false
        },
        {
            name: "Team Members",
            URL: "/app/users",
            icon: "users_sup.png",
            isHidden : permissions.find((obj)=> obj?.objectName === "Users")?.isHidden || false,
            readOnly : permissions.find((obj)=> obj?.objectName === "Users")?.permission.length === 1 && permissions.find((obj)=> obj?.objectName === "Users")?.permission.includes('read') || false
        }
        // {
        //     name: "Insights",
        //     URL: "/app/analytics",
        //     icon: "Insights.png",
        //     isHidden : permissions.find((obj)=> obj?.objectName === "Insights")?.isHidden || false,
        //     readOnly : permissions.find((obj)=> obj?.objectName === "Insights")?.permission.length === 1 && permissions.find((obj)=> obj?.objectName === "Insights")?.permission.includes('read') || false
        // }
    ];
    return menuItems;
};
export const patientMenu = (permissions) => {
    const menuItems =
    [
        {
            name: "Dashboard",
            URL: "/app/home",
            icon: "Home_sup.png",
            isHidden : permissions?.find((obj)=> obj?.objectName === "Home")?.isHidden || false,
            readOnly : permissions?.find((obj)=> obj?.objectName === "Home")?.permission.length === 1 && permissions.find((obj)=> obj?.objectName === "Home")?.permission.includes('read') || false
        },
        {
            name: "Activity",
            URL: "/app/patient-activity",
            icon: "activities_admin.png",
            isHidden : permissions?.find((obj)=> obj?.objectName === "Home")?.isHidden || false,
            readOnly : permissions?.find((obj)=> obj?.objectName === "Home")?.permission.length === 1 && permissions.find((obj)=> obj?.objectName === "Home")?.permission.includes('read') || false
        },
        {
            name: "Applications",
            URL: "/patient/application",
            icon: "Applicationuser_admin.png",
            isHidden : permissions?.find((obj)=> obj?.objectName === "Home")?.isHidden || false,
            readOnly : permissions?.find((obj)=> obj?.objectName === "Home")?.permission.length === 1 && permissions.find((obj)=> obj?.objectName === "Home")?.permission.includes('read') || false
        },
        {
            name: "Repository",
            URL: "/app/repository",
            icon: "repositryuser.png",
            isHidden : permissions?.find((obj)=> obj?.objectName === "Home")?.isHidden || false,
            readOnly : permissions?.find((obj)=> obj?.objectName === "Home")?.permission.length === 1 && permissions.find((obj)=> obj?.objectName === "Home")?.permission.includes('read') || false
        }
    ];
    return menuItems;
};
